import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import {
  getCurrentAccount,
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';

export const canAccessLuciAgent = (account, permissions = []) =>
  Boolean(
    account?.status === 'active' &&
      account?.features?.[FEATURE_FLAGS.LUCI_CONVERSATION_CONTROL] &&
      hasPermissions(['administrator'], permissions)
  );

export const resolveLuciAgentRouteAccess = (to, user) => {
  const safeUser = {
    ...(user || {}),
    accounts: Array.isArray(user?.accounts) ? user.accounts : [],
  };
  const account = getCurrentAccount(safeUser, to.params.accountId);
  const permissions = getUserPermissions(safeUser, to.params.accountId);
  if (canAccessLuciAgent(account, permissions)) return true;

  return {
    name: 'home',
    params: { accountId: to.params.accountId },
  };
};
